import React from "react";
import { IAuthContext } from "types/interfaces/IAuth";

const AuthContext = React.createContext({} as IAuthContext);

export default AuthContext;
